<template>
    <MainContent         :title="'Crear evento'">
        <FormEvento
            :evento="evento"
            :loading="loading"
            :errorsPeticion="errorsPeticion"
            @terminado="crearEvento"
        />
    </MainContent>
</template>

<script setup>
    import { ref } from 'vue';
    import store from '@/store';
    import router from '@/router';
    import FormEvento from '@/modules/admin/eventos/components/FormEvento.vue';
    import MainContent from '@/modules/admin/ui/MainContent.vue';
    import { useToast } from '@/composables/common/useToast';

    const evento = ref({
        recinto: false,
        status: 0,
        solicitar_datos: 0,
        provincia_id: null,
        n_max_asientos: 10,
        show_in_kiosk: false
    });

    const loading = ref(false);
    const errorsPeticion = ref({});
    const toast = useToast();


    function crearEvento(data) {
        loading.value = true;

        data.filters = {};

        if (data.place_obj) {
            // Same fallback-only behavior as Editar.vue: place_id is the
            // user's actual selection; place_obj stays in sync via the
            // multiselect handler so we never clobber.
            if (!data.place_id) {
                data.place_id = data.place_obj.id;
            }
        }

        // Extract IDs from objects if needed, otherwise keep as-is. BaseMultiselect
        // now emits integer IDs directly (post-fix to its handleSelect), so
        // this guard handles both: legacy hydrated objects and current numeric
        // IDs, instead of blowing up on `number.id`.
        if (data.equipo_local_id && typeof data.equipo_local_id === 'object') {
            data.equipo_local_id = data.equipo_local_id.id;
        }

        if (data.equipo_visitante_id && typeof data.equipo_visitante_id === 'object') {
            data.equipo_visitante_id = data.equipo_visitante_id.id;
        }

        if (data.division_id && typeof data.division_id === 'object') {
            data.division_id = data.division_id.id;
        }

        store.dispatch(store.getters.getConfig?.getVuexAlias?.('back.events.crear') || 'BACK_EVENTS_CREAR', data).then(res => {
            toast.success(res.data.message || 'Evento creado correctamente');
            if (!data.place_id && data.entradas_compartidas) {
                // The backend's `ok()` helper merges data at the response root
                // (no `data.data` wrapping), so the freshly-created event's id
                // comes back as `res.data.id`. We pass it to compartirEventos
                // so the subsequent POST /compartir-entradas can include
                // `event_id`, which the CompartirEntradasEventosRequest
                // requires. Without it, the second request fails with 403 and
                // the eventos_entradas_otros_eventos pivot never persists.
                const eventoId = res?.data?.id;
                Promise.resolve()
                    .then(() => compartirEventos(data.eventos_compartidos, eventoId))
                    .catch(() => {});
            }
            // router.push() returns a Promise; if it rejects (e.g. the lazy
            // chunk for back.events.index is still loading and the navigation
            // is interrupted), the rejection would propagate up and hit the
            // .catch() below as if the create itself had failed — which it
            // hasn't, since we're already past the 2xx. Swallow the
            // navigation rejection so the success path stays clean.
            router.push({ name: 'back.events.index' }).catch(() => {});
        }).catch(error => {
            errorsPeticion.value = error.response?.data?.errors || {};
            if (Object.keys(errorsPeticion.value).length === 0) {
                toast.error('Error al crear el evento. Inténtalo de nuevo.');
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function compartirEventos(eventos, eventoId) {
        loading.value = true;

        const params = {
            // `eventoId` is the id returned by BACK_EVENTS_CREAR
            // (res.data.evento_id, root level because the backend's `ok()`
            // helper merges data at the response root). Mirrors Editar.vue,
            // which sources it from props.evento_id (the route param).
            event_id: parseInt(eventoId),
            ids_eventos_entradas_compartidas: (eventos || []).map(evento => evento.id)
        };

        store.dispatch(store.getters.getConfig?.getVuexAlias?.('back.events.compartir-entradas') || 'BACK_EVENTS_COMPARTIR_EVENTOS', params).then(() => {
            toast.success('Se están cargando los eventos compartidos');
        }).finally(() => {
            loading.value = false;
        });
    }
</script>
